import React from "react";
import { ELCID } from "../models/IMediaToolkit";

export interface IDropdownOption {
    title: string;
    selectedTitle: string;
    type: string;
    func: () => void;
    selected?: boolean;
}

export interface IDropdownOptionsProps {
    lcid: ELCID;
    options: IDropdownOption[];
}

export const DropdownOptions: React.FunctionComponent<IDropdownOptionsProps> = (props) => {
    const [isOpen, setIsOpen] = React.useState<boolean>(false);

    document.addEventListener('click', () => {
        setIsOpen(false);
    })

    return (
        <>
            <div className="relative inline-block text-left ml-3">
                <div>
                    <button
                        type="button"
                        className="inline-flex justify-center w-full rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-indigo-500"
                        id={`btn_changeCurrentMediaPlan_${ELCID[props.lcid]}`}
                        aria-expanded="true"
                        aria-haspopup="true"
                        onClick={(ev) => {
                            ev.stopPropagation();
                            setIsOpen(!isOpen);
                        }}
                    >
                        {props.options.filter((option) => option.selected)[0].selectedTitle}
                        <svg
                            className="-mr-1 ml-2 h-5 w-5"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                            aria-hidden="true"
                        >
                            <path
                                fillRule="evenodd"
                                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                clipRule="evenodd"
                            />
                        </svg>
                    </button>
                </div>
                {isOpen ? (
                    <div
                        className="origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none"
                        role="menu"
                        aria-orientation="vertical"
                        aria-labelledby="menu-button"
                        tabIndex={-1}
                    >
                        <div className="py-1" role="none">
                            {props.options.map((option, idx) => {
                                return (
                                    <button
                                        type="button"
                                        className="text-gray-700 block px-4 py-2 text-sm hover:bg-aap-gray-100 text-left w-full"
                                        role="menuitem"
                                        tabIndex={-1}
                                        id={`btn_mediaPlanSwitch_${option.type}_${ELCID[props.lcid]}`}
                                        key={`menu-item-${idx}`}
                                        onClick={option.func}
                                    >
                                        {option.title}
                                    </button>
                                );
                            })}
                        </div>
                    </div>
                ) : null}
            </div>
        </>
    );
};
